angular.module('property')
    .controller('PropertyShowController', function ($scope, $rootScope, $uibModalInstance, data, PropertyService, Property, PropertyDeal, PropertyDealService, InvoiceService, Principal) {
        this.PropertyService = PropertyService;
        this.PropertyDealService = PropertyDealService;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.$onInit = () => {
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);
            this.showPricingDetails = false;
            this.activeTab = 0;
            this.item = data;

            Property.additionalRequiredProperties({id: this.item.id}).$promise.then(response => {
                this.additionalRequiredProperties = response;
                let amounts = this.additionalRequiredProperties.map(item => item.pricing.totalGross).filter(amount => amount != null && !isNaN(amount));
                this.additionalRequiredPropertiesTotalGross = InvoiceService.sumDecimal(amounts);
            })
        }
        this.togglePricingDetails = () => this.showPricingDetails = !this.showPricingDetails;

        $scope.$on('property.updated', () => this.cancel());
    })
